import React, { useEffect, useState } from 'react';
import Backdrop from 'components/Backdrop';
import Button from 'components/Button';

import './index.css';

type PopupProps = {
    title?: string;
    children?: React.ReactNode;
}

function Popup({
    title,
    children
}: PopupProps) {

    const [progress, setProgress] = useState(50);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setProgress(100); 
        }, 10); 

        return () => clearTimeout(timeout);
    }, []);
    
    return (
        <>
            <Backdrop />
            <div className='loadingPopup'>
                <div className='loadingPopup__Header'>Loading, please wait...</div>
                <div className='loadingPopup__Load'>
                    <div className='loadingPopup__bar'>
                        <div className='loadingPopup__barFill' style={{ width: `${progress}%` }}></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Popup;